import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { SpaceRecentListApi } from './repositories/apis/space-recent-list-api.interface';
import { SpaceRecentListModel, SpaceRecentListModelImpl } from './models/space-recent-list-model';
import { SpaceRecentListRepository } from './repositories/space-recent-list-repository.interface';
import { SpaceRecentListRepositoryImpl } from './repositories/space-recent-list-repository';
import { SpaceRecentListApiImpl } from './repositories/apis/space-recent-list-api';
import { SpaceRecentListService } from './services/space-recent-list-service.interface';
import { SpaceRecentListServiceImpl } from './services/space-recent-list-service';
export const spaceRecentListModule = new ContainerModule(bind => {
    bind(SpaceRecentListModel).to(SpaceRecentListModelImpl);
    bind(SpaceRecentListApi).to(SpaceRecentListApiImpl);
    bind(SpaceRecentListRepository).to(SpaceRecentListRepositoryImpl);
    bind(SpaceRecentListService).to(SpaceRecentListServiceImpl);
});
